// store all of the swal objects in one place
export const swalContents = {
    deleteEvent: {
        title: "Are you sure you want to delete this event?",
        text: "You will no longer be able to access this event",
        icon: "warning",

        buttons: {
            cancel: true,
            confirm: {
                text: "Delete Event",
                closeModal: false,
            }
        },
    },
    successDeleteEvent: {
        title: "Successfully Deleted the Event",
        icon: "success",
    },
    failDeleteEvent: {
        title: "Error",
        text: "We're sorry, we were unable to delete this event",
        icon: "error",
    },

    deleteNote: {
        title: "Are you sure you want to archive this note?",
        text: "You will no longer be able to access this note",
        icon: "warning",

        buttons: {
            cancel: true,
            confirm: {
                text: "Archive Note",
                closeModal: false,
            }
        },
    },
    successDeleteNote: {
        title: "Successfully Archived the Note",
        icon: "success",
    },
    failDeleteNote: {
        title: "Error",
        text: "We're sorry, we were unable to archive this note",
        icon: "error",
    },

    deleteGrassrootsAction: {
        title: "Are you sure you want to delete this Grassroots Action?",
        text: "You will no longer be able to access this Grassroots Action",
        icon: "warning",

        buttons: {
            cancel: true,
            confirm: {
                text: "Delete Grassroots Action",
                closeModal: false,
            }
        },
    },
    successDeleteGrassrootsAction: {
        title: "Successfully Deleted the Grassroots Action",
        icon: "success",
    },
    failGrassrootsAction: {
        title: "Error",
        text: "We're sorry, we were unable to delete this Grassroots Action",
        icon: "error",
    },

    deleteFile: {
        title: "Are you sure you want to delete this file?",
        text: "You will no longer be able to access this file",
        icon: "warning",

        buttons: {
            cancel: true,
            confirm: {
                text: "Delete File",
                closeModal: false,
            }
        },
    },
    successDeleteFile: {
        title: "Successfully Deleted the File",
        icon: "success",
    },
    failDeleteFile: {
        title: "Error",
        text: "We're sorry, we were unable to delete this File",
        icon: "error",
    },

    updateFile: {
        title: "Are you sure you want to replace the current file with this file?",
        text: "You will no longer be able to access the current file",
        icon: "warning",

        buttons: {
            cancel: true,
            confirm: {
                text: "Update File",
                closeModal: false,
            }
        },
    },
    successReplaceFile: {
        title: "Successfully updated file!",
        icon: "success",
    },
    failReplaceFile: {
        title: "Error",
        text: "We're sorry, we were unable to update this File",
        icon: "error",
    },

    deleteContact: {
        title: "Are you sure you want to delete this contact?",
        text: "You will no longer be able to access this contact",
        icon: "warning",

        buttons: {
            cancel: true,
            confirm: {
                text: "Delete Contact",
                closeModal: false,
            }
        },
    },
    successDeleteContact: {
        title: "Successfully Deleted the Contact",
        icon: "success",
    },
    failDeleteContact: {
        title: "Error",
        text: "We're sorry, we were unable to delete this Contact",
        icon: "error",
    },

    deletePublicOrganization: {
        title: "Are you sure you want to archive this Organization?",
        text: "You will no longer be able to access this Organization",
        icon: "warning",

        buttons: {
            cancel: true,
            confirm: {
                text: "Delete Organization",
                closeModal: false,
            }
        },
    },
    successDeletePublicOrganization: {
        title: "Successfully Deleted the Organization",
        icon: "success",
    },
    failDeletePublicOrganization: {
        title: "Error",
        text: "We're sorry, we were unable to archive this Organization",
        icon: "error",
    },

    patchSupporterAction: {
        title: 'Approve Message?',
        text: 'Are you sure you want to approve this message? Once you approve it, it will be delivered.',
        icon: 'warning',
        buttons: {
            cancel: true,
            confirm: {
                text: 'Yes, send it!',
                closeModal: false,
            }
        }
    },
    successPatchSupporterAction: {
        title: "Successfully approved the action",
        icon: "success",
    },
    failPatchSupporterAction: {
        title: "Error",
        text: "We're sorry, we were unable to approve this action",
        icon: "error",
    },
}

export default swalContents
